export default {"src":"https://images-cdn.curipod.com/d-bacd9c5f/_next/static/media/curiLogo.0c0d49a5.svg","height":298,"width":299};